import CryptoJS from 'crypto-js';
import { btoa, atob } from '../lib/helpers';
import { dataIntervalExport } from './params';
import { postApi } from '../lib/fetcher';

const inputerTrackingPengajuan = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      totalMerchants: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      totalPage: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
  },

  actions: {
    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        if (sortBy[0] == 'mid') {
          sort_by = `mid_static ${sort}`;
        } else {
          sort_by = `${sortBy[0]} ${sort}`;
        }
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/tracking/trackingpengajuan-inputer/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async viewMerchant(ctx, { date, id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/tracking/trackingpengajuan-inputer/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
      }
    },

    async viewDocument(ctx, { date, id, doc_type, type, download }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        account_id: id,
        type,
        doc_type,
        download,
        version: btoa(
          CryptoJS.SHA256(
            type.toString() +
              doc_type.toString() +
              id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/document/document/view`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = null;
      if (responseData?.code == '200') {
        resVal = responseData.data.base64_image;
      }
      return resVal;
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/export-tracking-pengajuan-merchant-inputer/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData.data.message,
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: `export-tracking-pengajuan-merchant-inputer`,
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};
export default inputerTrackingPengajuan;
